export enum AlertType {
  INFO = 'INFO',
  ERROR = 'ERROR',
}
